import { Component, Input } from '@angular/core';
import { Partij } from '@app/core/interfaces/partij';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';
import * as fromInvolvedParties from '@app/my-zone/pages/claims/store/actions/involvedParties.actions';
import * as fromRoot from '@app/store/app.reducer';
import { select, Store } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'ins-involved-parties-container',
    template: `
        <ins-involved-parties
            (loadInvolvedParties)="onLoadInvolvedParties($event)"
            [notifications]="claimErrors$ | async"
            [loaded]="loaded$ | async"
            [parties$]="parties$"
            [file_serial_number]="file_serial_number"
            [relation_id]="relation_id">
        </ins-involved-parties>
    `,
})
export class InvolvedPartiesContainer {
    @Input() file_serial_number: number;
    @Input() relation_id: number;

    public parties$: Observable<Partij> = this.store.pipe(
        select(fromMyClaims.getSelectedInvolvedParties));
    public claimErrors$: Observable<NotificationInterface> = this.store
        .pipe(
            select(fromMyClaims.getSelectedInvolvedPartiesErrors),
        );
    public loaded$ = this.store.pipe(select(fromMyClaims.isSelectedInvolvedPartiesLoaded));
    private subscription = new Subscription();

    constructor(
        private store: Store<fromRoot.State>,
    ) {}

    public onLoadInvolvedParties(payload): void {
        const subLoaded = this.loaded$.subscribe((loaded) => {
            if (loaded === undefined) {
                this.store.dispatch(new fromInvolvedParties.Load(payload));
            }
        });
        this.subscription.add(subLoaded);
    }
}
